import { createReducer, on } from '@ngrx/store';
import { initialIntegrateState } from './integrate_state';
import { integrateUpdate } from './integrate_actions';

export const integrateReducer = createReducer(
  initialIntegrateState,
  on(integrateUpdate, (_state, action) => (action.payload))
);
